import { Navigate } from 'react-router';
import { useMe } from '@/api/auth';
import { AREA_HOME, areasOf } from '@/auth/roles';
import { ErrorState, PageLoading } from '@/components/ui/States';
import { Container } from '@/components/ui/Page';

/** `/` sends people to the first area they belong to (customer → lead → tester), or to onboarding. */
export function HomeRedirect() {
  const me = useMe();
  if (me.isPending) return <PageLoading />;
  if (me.isError) {
    return (
      <Container narrow>
        <ErrorState error={me.error} onRetry={() => void me.refetch()} />
      </Container>
    );
  }
  const areas = areasOf(me.data);
  return <Navigate to={areas.length ? AREA_HOME[areas[0]] : '/welcome'} replace />;
}
